import { FC, useEffect, useState } from 'react';
import { useApiIsLoaded } from '@vis.gl/react-google-maps';
import { Autocomplete, TextField, Skeleton, SxProps } from '@mui/material';
import { SEARCH_PARAM_LOCATION, useSearch } from '@carcareers/contexts';

interface JobSearchLocationInputProps {
  sx?: SxProps;
}

export const JobSearchLocationInput: FC<JobSearchLocationInputProps> = ({ sx }) => {
  const apiIsLoaded = useApiIsLoaded();
  const { location: locationContext, updateSearchParams } = useSearch();

  const [location, setLocation] = useState(locationContext);

  useEffect(() => {
    updateSearchParams(SEARCH_PARAM_LOCATION, location);
  }, [location]);

  useEffect(() => {
    if (locationContext !== location) {
      setLocation(locationContext);
    }
  }, [locationContext]);

  return apiIsLoaded ? (
    <Autocomplete
      freeSolo
      id="job-search-location"
      options={[]}
      inputValue={location}
      renderInput={(params) => <TextField {...params} size="small" placeholder={'Location'} />}
      onOpen={(event) => {
        const input = document.getElementById('job-search-location') as HTMLInputElement;

        const autocomplete = new google.maps.places.Autocomplete(input, {
          fields: ['formatted_address', 'geometry'],
          componentRestrictions: { country: 'us' },
        });

        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          setLocation(place.formatted_address ?? '');
        });
      }}
      onInputChange={(_, newValue, reason) => {
        if (reason === 'clear' || (reason === 'input' && newValue.trim() === '')) {
          setLocation('');
          updateSearchParams(SEARCH_PARAM_LOCATION, undefined);
        } else if (reason === 'input') {
          setLocation(newValue);
          updateSearchParams(SEARCH_PARAM_LOCATION, newValue);
        }
      }}
      sx={{
        width: '33%',
        my: 1,
        display: { xs: 'none', sm: 'none', md: 'block' },
        ...sx,
      }}
    />
  ) : (
    <Skeleton
      variant="rounded"
      height={40}
      sx={{
        display: { xs: 'none', sm: 'none', md: 'block' },
        width: '33%',
        my: 1,
        ...sx,
      }}
    />
  );
};

export default JobSearchLocationInput;
